import * as slideValues from '@src/slide/application/service/menu-manager/menu-values/slide';
import { IEmptyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/empty-model.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

/**
 * 获取当前model所有的菜单属性对象
 * @param model
 */
export function getMenuValues(model: IEmptyModel): { [key: string]: any } {
    const slide = getAppServices().viewableServiceLayer.selectionService.currentSlide;
    if (slide) {
        return slideValues.getMenuValues(slide);
    }
    return {};
}

function getAppServices(): IEditorAppServices {
    return AppServiceProvider.getInstance()
        .getAppServices() as IEditorAppServices;
}


